import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const subscriptionsRecurringRevenueWidget: DashboardWidgetConfiguration = {
  widgetId: "subscriptions.recurring-revenue",
  name: "Recurring revenue",
  description: "Recurring revenue for the selected dashboard period.",
  apps: [
    "subscriptions",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "subscriptions.records",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "recurring_amount",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "active",
        operator: "eq",
        value: true,
      },
    },
  },
  inputs: {
    label: "Recurring revenue",
    subtext: "in the last 30 days",
    icon: "money",
    color: "success",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "$48,260",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
